import { useContext, useEffect, useState } from "react";
import moment from "moment";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Cliente";
import useClienteController from "../controllers/ClienteController";
import TableDefault from "../../../../components/grid/TableDefault";
import { ClienteContext } from "../contexts/ClienteContext";
import ModalTabelaPreco from "./ModalTabelaPreco";
import Chip from "../../../../components/basics/Chip";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { DeleteOutlined } from "@material-ui/icons";
import MaskService from "../../../../utils/mask/maskService";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "descricao",
    label: "Tabela de Preço",
    align: "left",
  },
  {
    id: "descontooriginal",
    label: "Desconto Padrão",
    align: "center",
  },
  {
    id: "descontopadrao",
    label: "Desconto Aplicado",
    align: "center",
  },
  {
    id: "dataexpirar",
    label: "Data Expiração",
    align: "left",
  },
];

export default function AccordionTabelaPreco() {
  const { expanded, customerPriceTable, setCustomerPriceTable, errors } =
    useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useClienteController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    (async () => {
      const newList = [];
      customerPriceTable.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            descontopadrao: `${MaskService.toMask(
              "decimal",
              item.descontopadrao || 0,
              2
            )} %`,
            descontooriginal: `${MaskService.toMask(
              "decimal",
              item.descontooriginal || 0,
              2
            )} %`,
            dataexpirar: moment(item.dataexpirar).format("DD/MM/YYYY"),
            acoes: (
              <SpeedDialErp
                actions={[
                  {
                    icon: <EditOutlinedIcon />,
                    name: "Editar",
                    action: () =>
                      handleEditItemTable(setOpen, setRowEdit, item, index),
                  },
                  {
                    icon: <DeleteOutlined />,
                    name: "Excluir",
                    action: () =>
                      handleRemoveItemTable(
                        setCustomerPriceTable,
                        setDataTable,
                        customerPriceTable,
                        index
                      ),
                  },
                ]}
              />
            ),
          })
      );

      setDataTable(newList);
    })();
  }, [
    customerPriceTable,
    setCustomerPriceTable,
    handleEditItemTable,
    handleRemoveItemTable,
  ]);

  return (
    <>
      {open && (
        <ModalTabelaPreco
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion expanded={expanded.customerPriceTable || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("customerPriceTable")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("customerPriceTable")}
                >
                  <Chip
                    label="TABELA DE PREÇOS"
                    bgcolor={
                      !expanded.customerPriceTable &&
                      errors.accordions &&
                      errors.accordions.includes("customerPriceTable")
                        ? "red"
                        : "default"
                    }
                  />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Tabela de Preço">
                    <IconButtonStyled onClick={() => setOpen(true)}>
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
